// User management api
export const SIGN_IN = 'user/signin';
export const SIGN_UP = 'user/signup/create-account';
export const SIGN_OUT = 'user/signout';
export const FORGOT_PASS = 'user/forgot-pass';
export const CHANGE_EMAIL_VERIFY = 'user/change-email';
export const VALIDATE_EMAIL = 'user/validate-email';
export const RESET_PASS = 'user/reset-pass';
export const JOIN_GUEST = 'user/join/guest';
export const VERIFY_EMAIL = 'user/verify';
export const VERIFY_CHANGE_EMAIL = 'user/verify-confirm';
export const VERIFY_TWO_STEP_AUTH = 'user/verify/two-step-auth';
export const USERS = 'user/';
export const ACCEPT_INVITATION = 'user/accept-invitation';
export const UPDATE_TWO_STEP_AUTH = 'user/update/two-step-auth';
export const UPDATE_STEALTH_MODE = 'user/update/stealth';
export const RESEND_TWO_STEP_AUTH = 'user/resend/two-step-auth';
export const DELETE_USER_AVATAR = 'user/avatar/remove';
export const USER_PAYMENT_METHODS = 'user/payment-methods';
export const ALL_USERS =`${USERS}get/all`;
export const GET_AVATAR_FILE_UPLOAD_URL = (id) => `${USERS}upload-url/${id}`;
export const GOOGLE_OAUTH_PATH = 'google/oauth-url';
export const GOOGLE_OAUTH_CONNECT = 'google/oauth-connect';
export const GOOGLE_OAUTH_DISCONNECT = 'google/oauth-disconnect';
export const OUTLOOK_OAUTH_PATH = '	outlook/oauth-url';
export const OUTLOOK_OAUTH_CONNECT = 'outlook/oauth-connect';
export const OUTLOOK_OAUTH_DISCONNECT = 'outlook/oauth-disconnect';
export const FACEBOOK_OAUTH_PATH = 'facebook/oauth-url';
export const FACEBOOK_OAUTH_CONNECT = 'facebook/oauth-connect';
export const INSTAGRAM_OAUTH_PATH = 'instagram/oauth-url';
export const INSTAGRAM_OAUTH_CONNECT = 'instagram/oauth-connect';
export const TWITTER_OAUTH_PATH = 'twitter/oauth-url';
export const TWITTER_OAUTH_CONNECT = 'twitter/oauth-connect';
export const LINKEDIN_OAUTH_PATH = 'linkedin/oauth-url';
export const LINKEDIN_OAUTH_CONNECT = 'linkedin/oauth-connect';
export const ROOMS = 'rooms';
export const GET_STT_AUTH_CONFIG = `${ROOMS}/get-stt-auth`;
export const GET_ROOM_USER_BY_PEERID = (roomId, peerId) => `${ROOMS}/user/${roomId}/${peerId}`;
export const GET_ROOM_FILE_UPLOAD_URL = (id) => `${ROOMS}/upload-url/${id}`;
export const SAVE_ROOM_FILE = (id) => `${ROOMS}/upload/${id}`;
export const GET_ROOM_FILES = (id) => `${ROOMS}/files/${id}`;
export const DELETE_ROOM_FILE = (id) => `${ROOMS}/file/${id}`;
export const REMOVE_ROOM_USER = (id) => `${ROOMS}/${id}/user`;
export const VERIFY_JOIN = `${ROOMS}/verify`;
export const CHAT_HISTORY = (id) => `${ROOMS}/chats/${id}`;

export const UPDATE_HOST = `${USERS}hosts`;
export const REMOVE_PARTICIPANT = (roomId) => `${USERS}participants/${roomId}`;

export const COMPANIES = 'company';

export const INVITATION = 'invitation';
export const CHECK_INVITATION_TOKEN = 'invitation/check-invitation-token';
export const GET_ROOM_BY_INVITATION_TOKEN = (token) => `${INVITATION}/room/${token}`;

export const GET_SERVERE_STATUS = 'status';

export const MEETINGS = 'meetings';

// Admin management api
export const ADMIN_PREFIX = 'admin';

export const ADMIN_USERS =`${ADMIN_PREFIX}/users`;
export const ADMIN_PARTICIPANTS =`${ADMIN_PREFIX}/participants`;
export const ADMIN_ROOM =`${ADMIN_PREFIX}/room`;
export const ADMIN_ROOMS_BY_USER = (id) => `${ADMIN_PREFIX}/room/user/${id}`;
export const ADMIN_PLAN =`${ADMIN_PREFIX}/plan`;
export const ADMIN_SUBSCRIPTIONS =`${ADMIN_PLAN}/subscriptions`;
export const ADMIN_SUBSCRIPTION_HISTORY = (customerId) => `${ADMIN_PLAN}/subscriptions/${customerId}`;
export const ADMIN_SUBSCRIPTION_CANCEL =`${ADMIN_SUBSCRIPTIONS}/cancel`;
export const ADMIN_SUBSCRIPTION_HOLD = `${ADMIN_SUBSCRIPTIONS}/hold`;
export const ADMIN_SUBSCRIPTION_DISABLE =`${ADMIN_SUBSCRIPTIONS}/disable`;
export const ADMIN_SUBSCRIPTION_ENABLE =`${ADMIN_SUBSCRIPTIONS}/enable`;
export const ADMIN_STATISTICS = `${ADMIN_PREFIX}/statistics`;

export const ADMIN_PLAN_BY_ID = (id) => `${ADMIN_PLAN}/${id}`;
export const ADMIN_USER_BY_ID = (id) => `${ADMIN_USERS}/${id}`;
export const ADMIN_USER_PASSWORD_BY_ID = (id) => `${ADMIN_USERS}/${id}/password`;
export const ADMIN_ROOM_BY_ID = (id) => `${ADMIN_ROOM}/${id}`;
export const ADMIN_STATISTICS_BY_YEAR = (year) => `${ADMIN_STATISTICS}/${year}`;
export const ADMIN_STATISTICS_BY_COUNTRY = (year) => `${ADMIN_STATISTICS}/country/${year}`;

/**
 * Recording API routes
 */
export const RECORDING_BOT_JOIN = `${USERS}join/recording-bot`;
export const RECORDING = 'recording';
export const START_RECORDING=`${RECORDING}/start`;
export const STOP_RECORDING=`${RECORDING}/stop`;
export const DELETE_RECORDING = (id) => `${RECORDING}/${id}`;
export const GET_RECORDING_FILES = (roomId) => `${RECORDING}/${roomId}`;

/**
 * Plan API routes
 */
export const PLAN = 'plan';

/**
 * Subscription API routes
 */
export const SUBSCRIPTION='subscription';
export const GET_SESSION = `${SUBSCRIPTION}/session`;